<div class="login-wrapper">
  <!-- Left Panel: Forget Password Form -->
  <div class="login-panel">
    <form [formGroup]="forgetPasswordForm" (ngSubmit)="submit()" (keyup.enter)="submit()" class="login-form">

      <!-- Lock Avatar -->
      <div class="avatar-circle">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="44" height="44">
          <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2z"/>
        </svg>
      </div>

      <!-- Title -->
      <div class="form-title">
        <h2>{{ 'users.forgetPassword.heading' | translate }}</h2>
        <p>{{ 'users.forgetPassword.subtitlePrefix' | translate }} {{ 'users.forgetPassword.subtitleAction' | translate }}</p>
      </div>

      <!-- Email Input -->
      <div class="form-group">
        <div class="input-wrapper">
          <span class="input-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
              <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
            </svg>
          </span>
          <input
            type="email"
            class="form-control"
            formControlName="email"
            [placeholder]="'users.forgetPassword.emailPlaceholder' | translate"
            autocomplete="email"
            maxlength="200"
          />
        </div>
        <app-control-error-display
          [control]="getControl('email')"
          [customErrors]="emailErrors">
        </app-control-error-display>
      </div>

      <!-- Submit Button -->
      <div class="form-group">
        <button
          id="submit"
          type="submit"
          class="btn-login"
          [disabled]="isSubmitting"
        >
          <span>{{ (isSubmitting ? 'users.forgetPassword.sending' : 'users.forgetPassword.confirm') | translate }}</span>
        </button>
      </div>

      <!-- Back to Login -->
      <div class="back-to-login">
        <a id="forgetpassword" (click)="goToLogin()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
            <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
          </svg>
          {{ 'users.forgetPassword.backToLogin' | translate }}
        </a>
      </div>
    </form>
  </div>

  <!-- Right Panel: Hero Section -->
  <div class="hero-panel">
    <!-- Decorative wave blobs -->
    <div class="wave-blob wave-blob-1"></div>
    <div class="wave-blob wave-blob-2"></div>
    <div class="wave-blob wave-blob-3"></div>
    <div class="wave-blob wave-blob-4"></div>
    <div class="hero-content">
      <h1 class="hero-title">{{ 'users.forgetPassword.resetPart1' | translate }}<br/>{{ 'users.forgetPassword.resetPart2' | translate }}</h1>
    </div>
  </div>
</div>
